<template>
  <div class="intro">
    <div class="top pt-2">
      <div class="mx-auto px-3 slider" :class="svgPadding" >
        <img alt="introduction image" :class="imgWidth" src="@/assets/intro.png">
      </div>
      <div class="intro-text mx-auto px-4">
        <div class="title mb-2">{{ $t('onboarding_intro.title') }}</div>
        <div class="mb-3">{{ $t('onboarding_intro.sub_title') }}</div>
      </div>
    </div>
    <v-footer
    height="auto" app fixed>
    <div class="px-3 mx-auto action " :class="actionPadding">
      <v-btn
        block
        data-test="btn-connect-jumia"
        @click="goToJumiaCentral"
        class="login-btn mx-auto mb-3"
        color="primary">{{ $t('onboarding_intro.connect_with_jumia') }}</v-btn>
      <span>{{ $t('onboarding_intro.login_suggestion') }}</span>
    </div>
  </v-footer>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import {setCookie} from "../util/cookies";
export default {
  name: 'intro',
  computed: {
    svgPadding () {
      return {
        'py-3': this.$vuetify.breakpoint.name === 'xs',
        'py-5': this.$vuetify.breakpoint.name !== 'xs'
      }
    },
    imgWidth () {
      if (this.$vuetify.breakpoint.name === 'xs') {
        return 'imgSmall'
      }
    },
    actionPadding () {
      return {
        'py-3': this.$vuetify.breakpoint.name === 'xs',
        'py-4': this.$vuetify.breakpoint.name !== 'xs'
      }
    }
  },
  methods: {
    ...mapActions({
      goToJumiaCentralAuth: 'app/goToJumiaCentralAuth'
    }),
    goToJumiaCentral(){
      setCookie('trigger-login',true, 1)
      this.goToJumiaCentralAuth()
    }
  }
}
</script>

<style scoped>
.v-content{
  background: white !important;
}
.intro {
  position: relative;
  display: flex;
  flex-direction: column;
  text-align: center;
  margin: 0 auto;
  height: 100%;
  width: auto;
  background: white;
}

.title {
  font-size: 19px!important;
}

img {
  max-width: 320px;
  width:60%;
}
.imgSmall{
    width:50%;
}

.top {
  background: white;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.slider {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.action,
.intro-text {
  width: 100%;
  max-width: 300px;
}
</style>
